module.exports = __webpack_public_path__ + "media/images/talent/case6-img01-c566ad3fffc1930f665a23a9436880d3.png";